import { FC, ReactNode } from "react";
import cn from "classnames";

import styles from "./hint.module.css";

type HintVariant = "success" | "warning" | "error" | "info";

type HintProps = {
  children: ReactNode;
  type?: HintVariant;
  className?: string;
};

export const Hint: FC<HintProps> = ({ children, type = "warning", className }) => {
  const typeStyles = cn(styles[type], styles.hintWrapper, className);

  return (
    <div className={typeStyles}>
      <div className={styles.borderWrapper} />
      <span className={styles.hint}>{children}</span>
    </div>
  );
};
